import { apiUrl, getLocalToken } from "../../apiClient";
import { endpoint } from "../endpoint";
const { createApi, fetchBaseQuery } = require("@reduxjs/toolkit/query/react");

export const admin_vendor_api = createApi({
  reducerPath: "vendor-workflow-reducer",
  baseQuery: fetchBaseQuery({
    baseUrl: `${apiUrl}/api`,
    prepareHeaders: (headers) => {
      let token = getLocalToken();
      if (token) {
        headers.set("Authorization", token);
      }
      headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    approver: builder.mutation({
      query: (data) => ({
        url: `${endpoint.admin_vendor}/vendor-workflow-data/${data?.vendor_id}`,
        method: "PATCH",
        body: data,
        headers: {
          Authorization: getLocalToken(),
        },
      }),
    }),
  }),
});

export const { useApproverMutation } = admin_vendor_api;
